import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SiteAnnouncementBanner from "@/components/SiteAnnouncementBanner";

const MainLayout = ({ children }) => {
  return (
    <div className="page-shell flex flex-col">
      <Navbar />
      <SiteAnnouncementBanner />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default MainLayout;
